module.exports = __webpack_public_path__ + "img/logo_jcjs.2506e6ff.png";